function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _async_to_generator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _ts_generator(thisArg, body) {
    var f, y, t, g, _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    };
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
import { createReducer } from "@reduxjs/toolkit";
import { memoize } from "proxy-memoize";
import { callPrivateApiAction } from "./api";
import { SORT_DESC } from "../features/app/ListFactory";
import { DEFAULT_NOTIFICATIONS_PER_PAGE, DEFAULT_NOTIFICATIONS_SORT_BY } from "../features/notifications/utils";
/*******************
 * ACTION TYPES
 *******************/ var actionTypes = {
    LOADED_NOTIFICATIONS: "notifications/LOADED_NOTIFICATIONS"
};
/*******************
 * REDUCER
 *******************/ export default createReducer({
    notifications: []
}, function(builder) {
    builder.addCase(actionTypes.LOADED_NOTIFICATIONS, function(state, action) {
        var payload = action.payload;
        return _object_spread_props(_object_spread({}, state), {
            notifications: payload.notifications
        });
    });
});
/*******************
 * ACTIONS
 *******************/ export var notificationsActions = {
    readNotifications: function readNotifications(param, abortControllerSignal) {
        var _param_ids = param.ids, ids = _param_ids === void 0 ? null : _param_ids, myCompanyId = param.myCompanyId;
        return /*#__PURE__*/ function() {
            var _ref = _async_to_generator(function(dispatch) {
                var error;
                return _ts_generator(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            _state.trys.push([
                                0,
                                2,
                                ,
                                3
                            ]);
                            return [
                                4,
                                dispatch(callPrivateApiAction("post", "/v1/my-companies/".concat(myCompanyId, "/notifications"), {
                                    ids: ids
                                }, {
                                    signal: abortControllerSignal
                                }))
                            ];
                        case 1:
                            _state.sent();
                            return [
                                3,
                                3
                            ];
                        case 2:
                            error = _state.sent();
                            throw error;
                        case 3:
                            return [
                                2
                            ];
                    }
                });
            });
            return function(dispatch) {
                return _ref.apply(this, arguments);
            };
        }();
    },
    getNotifications: function getNotifications(param, abortControllerSignal) {
        var myCompanyId = param.myCompanyId, _param_page = param.page, page = _param_page === void 0 ? 1 : _param_page, _param_perPage = param.perPage, perPage = _param_perPage === void 0 ? DEFAULT_NOTIFICATIONS_PER_PAGE : _param_perPage, filters = param.filters, _param_sortBy = param.sortBy, sortBy = _param_sortBy === void 0 ? DEFAULT_NOTIFICATIONS_SORT_BY : _param_sortBy, _param_sortDir = param.sortDir, sortDir = _param_sortDir === void 0 ? SORT_DESC : _param_sortDir;
        return /*#__PURE__*/ function() {
            var _ref = _async_to_generator(function(dispatch) {
                var params, response, error;
                return _ts_generator(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            params = {
                                page: page,
                                perPage: perPage,
                                sortBy: sortBy,
                                sortDir: sortDir
                            };
                            if (filters) {
                                params.filters = filters;
                            }
                            _state.label = 1;
                        case 1:
                            _state.trys.push([
                                1,
                                3,
                                ,
                                4
                            ]);
                            return [
                                4,
                                dispatch(callPrivateApiAction("get", "/v1/my-companies/".concat(myCompanyId, "/notifications"), params, {
                                    signal: abortControllerSignal
                                }))
                            ];
                        case 2:
                            response = _state.sent();
                            dispatch({
                                type: actionTypes.LOADED_NOTIFICATIONS,
                                payload: {
                                    notifications: response === null || response === void 0 ? void 0 : response.body.data
                                }
                            });
                            return [
                                3,
                                4
                            ];
                        case 3:
                            error = _state.sent();
                            throw error;
                        case 4:
                            return [
                                2
                            ];
                    }
                });
            });
            return function(dispatch) {
                return _ref.apply(this, arguments);
            };
        }();
    },
    getNotificationsList: function getNotificationsList(param, abortControllerSignal) {
        var myCompanyId = param.myCompanyId, _param_page = param.page, page = _param_page === void 0 ? 1 : _param_page, _param_perPage = param.perPage, perPage = _param_perPage === void 0 ? 10 : _param_perPage, filters = param.filters, _param_sortBy = param.sortBy, sortBy = _param_sortBy === void 0 ? DEFAULT_NOTIFICATIONS_SORT_BY : _param_sortBy, _param_sortDir = param.sortDir, sortDir = _param_sortDir === void 0 ? SORT_DESC : _param_sortDir;
        var params = {
            page: page,
            perPage: perPage,
            sortBy: sortBy,
            sortDir: sortDir
        };
        if (filters) {
            params.filters = filters;
        }
        return /*#__PURE__*/ function() {
            var _ref = _async_to_generator(function(dispatch) {
                return _ts_generator(this, function(_state) {
                    return [
                        2,
                        dispatch(callPrivateApiAction("get", "/v1/my-companies/".concat(myCompanyId, "/notifications"), params, {
                            signal: abortControllerSignal
                        })).then(function(response) {
                            return response.body;
                        })
                    ];
                });
            });
            return function(dispatch) {
                return _ref.apply(this, arguments);
            };
        }();
    }
};
/*******************
 * SELECTORS
 *******************/ var notifications = memoize(function(state) {
    return state.notifications.notifications;
});
export var notificationsSelectors = {
    getNotificationsList: memoize(function(state) {
        return notifications(state) || [];
    })
};
